import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import Iframe from 'react-iframe';
import * as FileSaver from 'file-saver';

/**
 * Container component for the IdCard page.
 * 
 */
class IdCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            idCardPdfSource: null,
            idcardImageSource: null,
            currentMember: null,
            shouldLoadData: true,
            downloading: false,
            showDownloadLoader: false,
            isMemberActive: true,
        };
        this.processIdCardPdf = this.processIdCardPdf.bind(this);
        this.downloadIdCard = this.downloadIdCard.bind(this);
        //this.printIdCard = this.printIdCard.bind(this);
        this.processIdCardImage = this.processIdCardImage.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate(this.props);
        logUI("MBHWeb.UI.IDCard.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps) {
        if (this.props.idCardImage !== prevProps.idCardImage || this.props.idCardError !== prevProps.idCardError) {
            if (this.props.idCardImage) {
                this.processIdCardImage();
            }
            else {
                this.setState({ showLoader: false });
            }
        }

        if (this.props.idCardPdf !== prevProps.idCardPdf || this.props.idCardError !== prevProps.idCardError) {
            if (this.props.idCardPdf) {
                this.processIdCardPdf().then(() => {
                    if (this.state.downloading) {
                        this.setState({ downloading: false });
                        this.downloadIdCard();
                    }
                });
            }
            else {
                this.setState({ showLoader: false });
            }
        }

        if ((this.props.AA || this.props.hpIdentity || this.props.swhp) && this.state.shouldLoadData && !this.props.isFetching) {
            var memberId = this.props.AA || this.props.swhp || this.props.hpIdentity.memberUserClaims.memberHccId;
            if (this.props.hpIdentity) {
                var isActive = this.props.hpIdentity.memberUserClaims.isActive;
                this.setState({ isMemberActive: isActive });
            }
            this.setState({ currentMember: memberId, shouldLoadData: false });
            this.props.getIdCardImage(memberId);
        }
    }

    componentWillUnmount() {
        var urlCreator = window.URL || window.webkitURL;
        urlCreator.revokeObjectURL(this.state.idCardPdfSource);
        urlCreator.revokeObjectURL(this.state.idCardImageSource);
    }

    async processIdCardImage() {
        var urlCreator = window.URL || window.webkitURL;
        let idCardImageSource = urlCreator.createObjectURL(this.props.idCardImage);
        this.setState({ idcardImageSource: idCardImageSource, showLoader: false });
    }

    async processIdCardPdf() {
        var urlCreator = window.URL || window.webkitURL;
        let idCardPdfSource = urlCreator.createObjectURL(this.props.idCardPdf);
        this.setState({ idCardPdfSource: idCardPdfSource });
    }

    downloadIdCard() {
        if (this.props.idCardPdf) {
            this.setState({ showDownloadLoader: false });
            FileSaver.saveAs(this.props.idCardPdf, "Health Insurance ID Card.pdf");
        } else {
            var memberId = this.props.AA || this.props.swhp || this.props.hpIdentity.memberUserClaims.memberHccId;
            this.setState({ currentMember: memberId, downloading: true, showDownloadLoader: true })
            this.props.getIdCardPdf(memberId);
        }
    }

    //printIdCard(url) {
    //    var iframe = document.createElement('iframe');
    //    document.body.appendChild(iframe);

    //    iframe.style.display = 'none';
    //    iframe.onload = function () {
    //        setTimeout(function () {
    //            iframe.focus();
    //            iframe.contentWindow.print();
    //        }, 1);
    //    };

    //    iframe.src = url;

    //    //let obj = document.getElementById("idcardimage");
    //    //obj.contentWindow.focus();
    //    //obj.contentWindow.print();
    //}

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title">
                            ID Card
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="idcard-wrapper">
                            <div className="idcard-container">

                                <div className="sub-header">
                                    {this.state.isMemberActive
                                        ?
                                    <div className="id-card-controls">
                                        <div className="semi-bold-text control-item" onClick={() => this.props.history.push("/requestnewidcard")}>
                                            <span className="icon-id-card control-icon"></span>
                                            Request New Card
                                        </div>
                                    </div>
                                        : <div></div>
                                    }
                                    <div className="id-card-controls push-right">
                                        {this.state.showDownloadLoader
                                            ?
                                            <div id="id-card-download-spinner" className="spinner">
                                                <div className="bounce1" />
                                                <div className="bounce2" />
                                                <div className="bounce3" />
                                            </div>
                                            : <div></div>
                                        }
                                        <div className="semi-bold-text control-item" onClick={() => this.downloadIdCard()}>
                                            <span className="icon-download control-icon"></span>
                                                Download as PDF
                                            </div>
                                        {/*
                                            <div className="semi-bold-text control-item" onClick={() => this.printIdCard(this.state.idCardPdfSource)} >
                                                <span className="icon-print control-icon"></span>
                                                Print
                                            </div>
                                        */}
                                    </div>
                                </div>

                                <div className="row alt-background idcard-display">
                                    <div className="col-12 idcard-front">
                                        <div className="idcard-holder">
                                            {this.state.showLoader
                                                ?
                                                <div id="id-card-spinner" className="spinner">
                                                    <div className="bounce1" />
                                                    <div className="bounce2" />
                                                    <div className="bounce3" />
                                                </div>
                                                :
                                                !this.props.idCardImage && this.props.idCardError
                                                    ? "ID card currently unavailable"
                                                    : <div className="idcard-image">
                                                        {!this.props.idCardImage && this.props.idCardError ? "ID card currently unavailable" : <img src={this.state.idcardImageSource} id="idcardimage" className="idcard-display-image" />}
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        hpIdentity: state.session.healthPlanUserProfile,
        idCardPdf: state.healthPlanServices.idCardPdf,
        idCardImage: state.healthPlanServices.idCardImage,
        idCardError: state.healthPlanServices.error,
        isFetching: state.healthPlanServices.isFetching,
        AA: state.domain.aai,
        swhp: state.domain.hi,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getIdCardPdf: (memberId) => dispatch({ type: types.HP_GET_IDCARD_START, memberId: memberId }),
        getIdCardImage: (memberId) => dispatch({ type: types.HP_GET_IDCARD_IMAGE_START, memberId: memberId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdCard));
